import { createStore } from "owa-satcheljs";

// Define the possible sort columns - using literal types for type safety
export type SortColumn = "dueDate" | null;

// Define sort directions - standard ascending/descending
export type SortDirection = "ascending" | "descending";

export interface PstTasksStore {
    showPstTasks: boolean;
    selectedTaskId?: string;
    isDialogOpen: boolean;
    sortColumn: SortColumn;
    sortDirection: SortDirection;
}

const getStore: () => PstTasksStore = createStore<PstTasksStore>("PstTasksStore", {
    showPstTasks: false,
    isDialogOpen: false,
    // Initialize with no sorting (null) and default direction
    sortColumn: null,
    sortDirection: "descending", // Default to descending (newest dates first)
});

export default getStore;
